import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {programsService} from "../../../services/programsService/programsService";
import Loader from "../../../components/common/Loader";
import YoutubeSession from "./YoutubeSession";
import DashboardProgramsList from "./DashboardProgramsList";
import Calendar from "../../../components/Calendar/Calendar";
import DashboardAnnouncements from "./DashboardAnnouncements";
import {MasterClassService} from "../../../services/masterClassService/masterClassService";
import ProgressBar from "@ramonak/react-progress-bar";
import FavoriteMasterclasses from "./FavoriteMasterclasses";
import CommentLoader from "../../../components/common/CommentLoader";

const InstitutionUserDashboard = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [state, setState] = useState({
        loader: false,
    });

    const [programs, setPrograms] = useState([]);
    const [masterClasses, setMasterClasses] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setIsLoading(true);
        getAllPrograms();
        getMasterclasses();
    }, []);

    const getAllPrograms = async () => {
        try {
            const response = await programsService.getPrograms();

            setPrograms(response.data['programs']);

            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    const getMasterclasses = async () => {
        try {
            const response = await MasterClassService.getMasterClasses();

            setMasterClasses(response.data.data);

            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    return (
        <>
            {state?.loader || isLoading ? (
                <Loader />
            ) : (
                <>
                    <div className="container-fluid dashboard-content">
                        <div className="row mb-5">
                            <DashboardAnnouncements />
                            <div className="col-md-6 mb-4 mb-md-0">
                                <h1>Driving Educational Growth with Expert Training</h1>
                                <span className="fs-5 text-second fs-lg-4">
                                   ACTE Masterclass Series provides educational institutions with highly impactful professional development masterclasses featuring influential thought leaders, subject matter experts, and insightful coaching. We ignite a tipping point that advances institutional culture forward faster.
                                </span>
                                <div className="d-flex mt-3">
                                    <button className="btn btn-primary me-2 py-2 px-3" onClick={() => navigate('/programs')}>Choose Program</button>
                                    <a target="_blank" href="https://www.catapultlpd.com/catapult-manifesto">
                                        <button className="btn btn-primary-info py-2 px-3">
                                            Learn More
                                        </button>
                                    </a>
                                </div>
                            </div>

                            <div className="col-md-6 text-center">
                                <div className="master-class__image">
                                    <YoutubeSession video={"https://vimeo.com/1058261946"}/>
                                </div>
                            </div>
                        </div>
                        <div className="single-lesson-grid">
                            <div>
                                <div className="py-3">
                                    <DashboardProgramsList
                                        programs={programs}
                                    />
                                </div>
                                {masterClasses.length !== 0 &&
                                    <div className="py-3">
                                        <h3>Masterclasses</h3>
                                        <div className="row">
                                            {masterClasses?.map((masterClass) => {
                                                return (
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-12">
                                                        <div className="card text-white m-3 p-4 program-masterclass-card rounded-3" onClick={() => navigate(`/master-classes/${masterClass.id}`)}>
                                                            <img src={masterClass?.cover_image}
                                                                 className="card-img-top program-masterclass-card-thumbnail img-fluid rounded-3 mb-3"
                                                                 alt={masterClass?.name}/>
                                                            <h5 className="card-title mb-2">{masterClass?.name}</h5>
                                                            <ProgressBar completed={masterClass.progress} bgColor="#1c64f2" baseBgColor="#374151"
                                                                         className={`w-100 progressbar-count mt-2 ${masterClass.progress > 5 ? '' : 'progressbar-count__hide-value'}`} />
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        {masterClasses.length === 10 &&
                                            <div className="d-flex justify-content-end">
                                                <button className="btn btn-primary" onClick={() => navigate("/master-classes")}>View More</button>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <div className="py-3">
                                <h3>Events</h3>
                                <div className="card-layout-calendar">
                                    <Calendar/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default InstitutionUserDashboard;